<template>
  <div>
    <b-container v-if="!hideStepperControls" style="padding-bottom: 30px">
      <b-col>
        <div class="step-indicators">
          <span />
          <b-progress :max="100" class="step-indicators-line">
            <b-progress-bar variant="stepper-done" :value="percentCompleted" />
            <b-progress-bar
              variant="stepper-todo"
              :value="100 - percentCompleted"
            />
          </b-progress>
          <div style="z-index: 2" v-for="(step, index) in steps">
            <div
              @click="handleClick(step)"
              class="step-indicator"
              :class="{
                'step-indicator-active-step': step < currentStep,
                'step-indicator-inactive-step': step >= currentStep,
              }"
            >
              {{ index + 1 }}
            </div>
            <div @click="handleClick(step)" class="step-indicators-title">
              {{ stepLabels[step] }}
            </div>
          </div>
        </div>
      </b-col>
    </b-container>
    <b-container>
      <div v-if="stepsComps && steps && stepsComps.length === steps.length">
        <component
          @stepper-change="changeStep"
          :is="stepComponents?.[activeStep - 1]"
        />
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Stepper",
  data() {
    return {
      stepsComps: [],
      component: "NotFound",
      activeStep: null,
    };
  },
  methods: {
    changeStep: function (step) {
      this.activeStep = step;
    },
  },
  computed: {
    percentCompleted: function () {
      let percent = 0;
      const increment = 100 / this.steps.length;
      for (const i in this.steps) {
        if (this.currentStep >= this.steps[i]) {
          percent += increment;
        }
      }
      if (percent > 100) {
        percent = 100;
      }
      // Avoid changing color past the edge of the current circle.
      return percent - 5;
    },
  },
  mounted() {
    this.stepsComps = this.stepComponents;
    this.activeStep = this.currentStep;
  },
  components: {},
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    stepComponents: {
      type: Array,
      required: false,
    },
    stepLabels: {
      type: Object,
      required: true,
    },
    handleClick: {
      type: Function,
      default: function () {},
    },
    hideStepperControls: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.step-indicators {
  position: relative;
  display: flex;
  justify-content: space-between;
}

.step-indicator-active-step,
.progress-bar .bg-stepper-done {
  border-color: #b6b6b6;
  color: #b6b6b6;
}

.step-indicator-inactive-step,
.progress-bar .bg-stepper-todo {
  border-color: black;
  color: black;
}

.step-indicator {
  border: 4px solid;
  border-radius: 50%;
  height: 64px;
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  z-index: 2;
  background-color: white;
  box-sizing: border-box;
}

.step-indicators-line {
  height: 1rem;
  position: absolute;
  top: 30%;
  left: 24px;
  right: 24px;
  transform: translateY(-50%);
  z-index: 1;
}

.step-indicators-line .bg-stepper-done {
  border-color: #b6b6b6;
  background-color: #b6b6b6;
}

.step-indicators-line .bg-stepper-todo {
  border-color: black;
  background-color: black;
}

.step-indicators-title {
  display: flex;
  max-width: 60px;
  text-align: center;
  justify-content: center;
  color: black;
  z-index: 2;
}
</style>
